import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isEmpty, toArray } from 'lodash';

import { PATH } from '../../../../constants/path';
import { HeadComponent } from '../../../HeadComponent';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';
import { fetchAccountMessagesIfNeeded } from '../../../../services/account/mymessages/actions';
import { fetchContactRequestReasonIfNeeded } from '../../../../services/contactrequest/actions';

import './MessagePage.scss';

const messageAnswerParagraph = (text, key) => (
    <p key={key}>{convertHtmlToReactDomWithParams(text)}</p>
);

export class MessagePage extends React.Component {
    renderConditionnalOnMessageAnswer(message, UNDEFINED, NO_ANSWER_AVAILABLE) {
        if (isEmpty(message)) return UNDEFINED;
        const answers = message.answers;
        return isEmpty(answers)
            ? messageAnswerParagraph(NO_ANSWER_AVAILABLE)
            : answers.map((answer, key) => messageAnswerParagraph(answer.content, key));
    }

    renderContactRequestReasonLabel(message, UNDEFINED) {
        if (isEmpty(message)) return UNDEFINED;
        const id = message.contactRequestReasonId;
        const reason = this.props.contactrequestreasons.find(e => e.id === id);
        if (isEmpty(reason)) return UNDEFINED;
        return reason.label;
    }

    componentDidMount() {
        this.props.fetchContactRequestReasonIfNeeded();
        this.props.fetchAccountMessagesIfNeeded();
    }

    render() {
        const { i18n, message, user, common } = this.props;
        return (
            <div id="p-account-messages-details" className="container">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_MESSAGE_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <div className="message-header">
                    <h3>{i18n.PAGE_TITLE}</h3>
                    <Link to={PATH.ACCOUNT_MESSAGE_PATH} className="back-return-button">
                        {i18n.RETURN_TO_MESSAGES}
                    </Link>
                </div>
                <section className="info">
                    <p>
                        <span className="info-field">{i18n.FROM}</span> {user.lastname}{' '}
                        {user.firstname}
                    </p>
                    <p>
                        <span className="info-field">{i18n.SUBJECT}</span>{' '}
                        {this.renderContactRequestReasonLabel(message, common.UNDEFINED)}
                    </p>
                    <p>
                        <span className="info-field">{i18n.TO}</span> {i18n.CUSTOMER_SERVICE}
                    </p>
                </section>
                <section className="messages">
                    <div className="content">
                        <h4 className="info-field">{i18n.MESSAGE}</h4>
                        <p>{message && message.request}</p>
                    </div>
                    <div className="answer">
                        <h4 className="info-field">{i18n.ANSWER}</h4>
                        {this.renderConditionnalOnMessageAnswer(
                            message,
                            common.UNDEFINED,
                            common.NO_ANSWER_AVAILABLE
                        )}
                    </div>
                </section>
            </div>
        );
    }
}

MessagePage.propTypes = {
    common: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
    contactrequestreasons: PropTypes.array.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const messages = toArray(state.account.mymessages.messages);

    return {
        common: state.i18n.common,
        i18n: state.i18n.page.ACCOUNT.MESSAGEDETAILS,
        message: messages.find(message => message.id === Number(ownProps.match.params.id)),
        user: state.account.user,
        contactrequestreasons: state.contactrequest
            ? state.contactrequest.contactrequestreasons
            : []
    };
};
const mapDispatchToProps = {
    fetchContactRequestReasonIfNeeded,
    fetchAccountMessagesIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/mymessages/MessagePage.js